import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4eadd37a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mr-10" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("发票流水勾销")
const _hoisted_3 = { class: "convertNumb" }
const _hoisted_4 = { class: "convertNumb" }
const _hoisted_5 = { class: "convertNumb" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("财务费用前：发票金额 + 订单金额 - 收款金额")
const _hoisted_7 = { style: {"textAlign":"center"} }
const _hoisted_8 = { class: "numberRectangle" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "+", -1))
const _hoisted_10 = { class: "numberRectangle" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "-", -1))
const _hoisted_12 = { class: "numberRectangle" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "=", -1))
const _hoisted_14 = { class: "numberRectangle" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode("填入财务费用")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("填入差异")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("填入坏账")
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = {
  key: 0,
  class: "mt-10",
  style: {"textAlign":"center"}
}
const _hoisted_21 = /*#__PURE__*/_createTextVNode("提示：在没有选择流水的时候，可以选择一个日期")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("财务费用后：发票金额+订单金额-收款金额-财务费用-差异-坏账")
const _hoisted_23 = { style: {"textAlign":"center"} }
const _hoisted_24 = { class: "numberRectangle" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "+", -1))
const _hoisted_26 = { class: "numberRectangle" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "-", -1))
const _hoisted_28 = { class: "numberRectangle" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "-", -1))
const _hoisted_30 = {
  class: "numberRectangle",
  style: {"background":"rgb(201, 220, 255)"}
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "-", -1))
const _hoisted_32 = {
  class: "numberRectangle",
  style: {"background":"rgb(201, 220, 255)"}
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "-", -1))
const _hoisted_34 = {
  class: "numberRectangle",
  style: {"background":"rgb(201, 220, 255)"}
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "=", -1))
const _hoisted_36 = { class: "numberRectangle" }
const _hoisted_37 = { class: "dialog-footer" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_39 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_40 = /*#__PURE__*/_createTextVNode("确定")

import { ref, h, reactive,  computed, watch } from 'vue'
import { formatNumber, getNumber, formatTime } from '@/utils/index'
import { ElMessage, ElMessageBox } from 'element-plus'
import dayjs from 'dayjs'
import _ from 'lodash'
import Api from '@/http/modules/index'
import { add, number, bignumber } from 'mathjs'

export default /*#__PURE__*/_defineComponent({
  props: {
  flowRows: { type: Array, default: [] },
  invRows: { type: Array, default: [] },
  orderRows: { type: Array, default: [] },
},
  emits: ['compareSuccess'],
  setup(__props, { expose, emit }) {

const props: any = __props

const {
  // 换算汇率
  'POST/verification/translation/covert_rate_new': covert_rateApi,
  // 流水发票新勾销
  'POST/verification/liquidate': flow_invoice_verifyApi,
  // 根据发票获取订单(坏账相关)
  'POST/verification/translation/invoices/orders': invoicesOrdersApi,
  // 汇率_手动更新
  'POST/exchange_rates/manual_sync': manual_syncApi,
  // 转汇为USD金额
  'GET/exchange_rates/convert/usd': convertUsdApi,
  // 勾销校验
  'POST/verification/liquidate/validate': validateApi,
} = Api;


const btnFg = ref<boolean>(false)



const compareBtnFg = ref<boolean>(false)
let compareTable: any = ref([])
const compareFg = ref<boolean>(false)
const compareObj: any = reactive({
  // 财务费用
  financialExpenses: 0,
  // 差异
  balance: 0,
  // 坏账
  badDebt: 0,
  // 备注
  notes: '',
  bad: false
})

// 转换成Usd后的金额
const usdConvertObj = reactive({
  financialExpenses: 0,
  balance: 0,
  badDebt: 0,
})
const usdConvert = (number: number, key: string) => {
  if(!number){
    // 默认为0
    compareObj[key] = 0
  }
  return convertUsdApi({
    amount: number || 0,
    currency: compareTable.value[0].currency,
  }).then((usdNumber: number) => {
    usdConvertObj[key] = usdNumber
    return usdNumber
  })
}

let orderListFg = ref<boolean>(false)
let badOrderList: any = ref([])
let badDebtOrderRows: any = ref([])
/* watch(compareFg, async (newFg: boolean) => {
  if(!newFg) return;
  // 打开dialog后，获取订单
  orderListFg.value = true
  try {
    badOrderList.value = await invoicesOrdersApi({invoices: props.invRows})
    orderListFg.value = false
  } catch (error) {
    orderListFg.value = false
  }
  
}) */
// 计算勾选发票金额总计
let orderListAmount = computed(() => {
  return badDebtOrderRows.value.reduce((numb: number, row: any) => {
    numb += Number(row.amount)
    return numb
  }, 0).toFixed(2)
})

// 计算发票金额合计
/* let originalInvoice = computed(() => {
  // 如果有选择订单
  return props.invRows.reduce((numb: number, _inv: any,) => {
    numb += _inv.invoiceAmount
    return numb
  }, 0)
}) */

// 计算订单金额合计
/* const orderAmount = computed(() => {
  return props.orderRows.reduce((numb: number, _order: any,) => {
    return numb += Number(parseFloat(_order.amount).toFixed(2))
  }, 0).toFixed(2)
})
 */
// 初始化勾销函数
const compareHandle = async () => {
  if (props.orderRows.length === 0 && props.invRows.length === 0) {
    ElMessage.warning('请至少选择一条订单，或至少一张发票')
    return
  }
  compareObj.bad = false
  const firstCustId = props.flowRows.find((_cust: any) => _cust.customerId !== null)?.customerId

  const finstFlowCurrency = props.flowRows[0]?.receiptCurrency?.trim().toUpperCase()
  const finstInvCurrency = props.invRows[0]?.currency?.trim().toUpperCase()
  const finstOrderCurrency = props.orderRows[0]?.currency?.trim().toUpperCase()

  // 判断发票币种是否相同
  /* if(props.invRows.findIndex((inv: any) => inv.currency?.trim().toUpperCase() !== finstInvCurrency) !== -1){
    ElMessage.warning('发票币种不相同')
    return
  } */
  // 判断订单币种是否一致
  /* if (props.orderRows.findIndex((e: any) => e.currency?.trim().toUpperCase() !== finstOrderCurrency) !== -1){
    ElMessage.warning('订单币种不一致')
    return
  } */

  // 判断流水币种是否一致
  if( props.flowRows.length !== 0){
    if (props.flowRows.findIndex((e: any) => e.receiptCurrency?.trim().toUpperCase() !== finstFlowCurrency) !== -1) {
      ElMessage.warning('流水币种不一致')
      return
    }
  } else {
    // 判断订单币种是否一致
    if (props.orderRows.findIndex((e: any) => e.currency?.trim().toUpperCase() !== finstOrderCurrency) !== -1){
      ElMessage.warning('订单币种不一致')
      return
    }
  }
  // 判断发票订单币种是否一致
  /* if(finstInvCurrency && finstOrderCurrency && finstInvCurrency !== finstOrderCurrency){
    ElMessage.warning('发票订单币种不一致')
    return
  } */

  // 判断流水客户是否一致
  if(firstCustId && props.flowRows.findIndex((_cust: any) => _cust.customerId !== null && _cust.customerId !== firstCustId) !== -1){
    ElMessage.warning('流水客户ID不一致')
    return
  }

  // 判断流水和发票、订单币种是否一致
  /* if(props.flowRows.length > 0 && props.invRows.length > 0 && finstFlowCurrency !== finstInvCurrency){
    await ElMessageBox.alert( '流水和发票币种不一致，请谨慎操作', '提示',  { confirmButtonText: '确定', 'show-close': false })
  } else if(props.flowRows.length > 0 && props.orderRows.length > 0 && finstFlowCurrency !== finstOrderCurrency){
    await ElMessageBox.alert( '流水和订单币种不一致，请谨慎操作', '提示',  { confirmButtonText: '确定', 'show-close': false })
  } */

  // 深克隆订单,用于填写坏账
  badOrderList.value = _.cloneDeep(props.orderRows);

  // 计算流水回款合计(收款金额本位币)
  let flowTotal = props.flowRows.reduce((numb: number, _flow: any,) => {
    numb += _flow.standardMoney || 0
    return numb
  }, 0)
  
  // 流水收款金额合计
  let originalFlow = props.flowRows.reduce((numb: number, _flow: any,) => numb += (_flow.receiptAmount || 0), 0)

  // 流水手续费合计
  let handlingFee = props.flowRows.reduce((numb: number, _flow: any,) => {
    numb += _flow.handlingFee || 0
    return numb
  }, 0)
  
  // =--计算汇率转换--=
  let _originalFlow: any = 0
  // 有流水，需要转换汇率
  // if (props.flowRows.length !== 0) {}
  
  // 计算汇率转换
  let orderAmount
  let invoiceAmount
  compareBtnFg.value = true
  try {
    // 只转换流水的汇率
    const convertRep = await covert_rateApi({
      flowIds: props.flowRows.map((e: {id: number}) => e.id),
      orderNos: props.orderRows.map((e: {no: number}) => e.no),
      invoices: props.invRows
    })
    orderAmount = convertRep.orderAmount
    invoiceAmount = convertRep.invoiceAmount
    compareBtnFg.value = false
  } catch (error) {
    console.log(error)
    compareBtnFg.value = false
  }
  
  // 计算发票本位币合计
  let invoiceTotal = props.invRows.reduce((numb: number, _inv: any,) => numb += _inv.standardMoney, 0)
  // 发票原始金额合计
  let originalInvoice = props.invRows.reduce((numb: number, _inv: any,) => numb += _inv.invoiceAmount, 0)


  // 填充表格
  compareTable.value = [{
    flowTotal: parseFloat(flowTotal.toFixed(2)),
    originalFlow: Number(originalFlow.toFixed(2)),
    handlingFee: parseFloat(handlingFee.toFixed(2)),
    invoiceTotal: Number(invoiceTotal.toFixed(2)),
    originalInvoice: invoiceAmount,
    currency: finstFlowCurrency || finstInvCurrency || finstOrderCurrency,
    invoiceCurrency: finstInvCurrency,
    // 订单金额合计
    orderAmount: orderAmount,
    // 所有金额合计
    totalAmount: Number(orderAmount.value) + parseFloat(invoiceTotal.toFixed(2)) + parseFloat(flowTotal.toFixed(2))
  }]
  compareFg.value = true
}

const fillCompareObj = (prop: string) => {
  const resultNumb = Number((compareTable.value[0].originalInvoice + compareTable.value[0].orderAmount - compareTable.value[0].originalFlow).toFixed(2))
  compareObj[prop] = resultNumb
  usdConvert(resultNumb, prop)
}

// 自动填充坏账
const closedhzChange = (val: boolean) => {
  badOrderList.value.map(row => {
    row.badDebt = row.amount
  })
}

const isShowExchange = ref<boolean>(false)
const exchangeRang: any = ref([])
let confirmCloseTime = ref('')
const submitVerify = async () => {
  
  // 判断财务费用勾销后，是否为0
  if (Math.abs(parseFloat(
    (compareTable.value[0].originalInvoice +
      compareTable.value[0].orderAmount -
      compareTable.value[0].originalFlow -
      (compareObj.financialExpenses || 0) -
      (compareObj.balance || 0) -
      (compareObj.badDebt || 0)
    ).toFixed(2))) !== 0) {
    ElMessage.warning('财务费用后计算结果不为0')
    return
  }
  // 如果没有选择流水，则日期必选
  if(props.flowRows.length === 0 && !confirmCloseTime.value){
    ElMessage.warning('请选择日期')
    return
  }
  // 坏账不为0，判断订单金额和为坏账金额
  let badDebtMap: any = { }
  if(compareObj.badDebt){

    // 计算弹框下方相关订单中坏账金额相加数量，
    let sumBadBebt = badDebtOrderRows.value.reduce((numb: number, order: any, index: number) => {
      if(!Number.isNaN(order.badDebt)){
        badDebtMap[order.id] = parseFloat(order.badDebt)
        return number(add(bignumber(numb), bignumber(order.badDebt)))
      }
      return numb
    }, 0)

    // 弹框下方相关订单未填写坏账
    if(sumBadBebt === 0){
      ElMessage.warning('请填写各订单坏账金额')
      return
    }
    // 各订单坏账金额相加不等于坏账总金额
    if(sumBadBebt !== Number(compareObj.badDebt)){
      ElMessage.warning('各订单坏账金额相加不等于坏账总额')
      return 
    }
  }

  let noInvoiceOrders = props.orderRows.reduce((arr: any, row: any) => {
    if(!row.invoiceNo){
      arr.push(row.id)
    }
    return arr
  }, [])
  let orderIdInvoiceNoMap = props.orderRows.reduce((obj: any, row: any) => {
    if(row.invoiceNo){
      obj[row.id] = row.invoiceNo
    }
    return obj
  }, {})
  // 提交
  btnFg.value = true
  const params = {
    // 客户ID
    customerId: props.flowRows[0]?.customerId,
    balance: {
      ...compareTable.value[0],
      financialExpenses: compareObj.financialExpenses ? compareObj.financialExpenses : 0,
      balance: compareObj.balance ? compareObj.balance : 0,
      badDebt: compareObj.badDebt ? compareObj.badDebt : 0,
      notes: compareObj.notes,
    },
    flowIds: props.flowRows.map((e: any) => e.id),
    noOrderInvoices: props.invRows,
    orderIds: props.orderRows.map((e: any) => e.id),
    bad: compareObj.bad,
    // invoices: props.invRows,
    // deliveredOrders: props.orderRows,
    confirmCloseTime: confirmCloseTime.value,
    badDebtMap,
    noInvoiceOrders,
    orderIdInvoiceNoMap,
  }
  // 提交前校验
  try {
    let tipContentArr = await validateApi(params)
    if(tipContentArr.length > 0){
      /* const str = tipContentArr.reduce((str: string, item: any, index: number) => {
        return str += (index + 1) + item.tipStr + ':' + item.tipContent + '。'
      }, '') */
      // await ElMessageBox.alert(str, '提示')
      await ElMessageBox({
        title: '提示',
        showCancelButton: true,
        message: h(
          'p', null, 
          tipContentArr.map((item: any, index: number) => {
            return h('p', null, (index + 1) + item.tipStr + ':' + item.tipContent + '。')
          })
        )
      })
    }
  } catch (error) {
    btnFg.value = false
    return
  }
  try {
    await flow_invoice_verifyApi(params, {timeout: 60000 * 3})
    ElMessage.success('成功')
    btnFg.value = false
    compareFg.value = false
    // 触发父组件勾销成功
    emit('compareSuccess')
  } catch (error) {
    if(error?.response?.data?.message.includes('当天汇率表中缺失')){
      isShowExchange.value = true
    }
    
    btnFg.value = false
  }

}

const isSubmitLoading = ref<boolean>(false)
const submitExchange = () => {
  if(exchangeRang.value.length === 0){
    ElMessage.warning('请选择日期范围')
    return
  }
  isSubmitLoading.value = true
  manual_syncApi({
    startDate: exchangeRang.value[0],
    endDate: exchangeRang.value[1],
  }).then(() => {
    ElMessage.success('成功')
    isShowExchange.value = false
    exchangeRang.value = []
  }).finally(() => {
    isSubmitLoading.value = false
  })
}

const closeHandle = () => {
  // dialogc关闭完成后，清空财务费用和差异
  compareObj.financialExpenses = 0
  compareObj.balance = 0
  compareObj.badDebt = 0
  compareObj.notes = ''

  // 清空汇率转换
  usdConvertObj.financialExpenses = 0
  usdConvertObj.balance = 0
  usdConvertObj.badDebt = 0

}

expose({
  compareObj,
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createVNode(_component_el_button, {
      loading: compareBtnFg.value,
      class: "mb-10 mt-10",
      type: "primary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (compareHandle()))
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["loading"]),
    _createVNode(_component_el_dialog, {
      draggable: "",
      width: "70%",
      modelValue: compareFg.value,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((compareFg).value = $event)),
      title: "发票流水勾销",
      onClose: closeHandle,
      top: "45px"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_37, [
          _createVNode(_component_el_button, {
            type: "primary",
            loading: btnFg.value,
            onClick: _cache[14] || (_cache[14] = ($event: any) => (submitVerify())),
            class: "ml-10"
          }, {
            default: _withCtx(() => [
              _hoisted_38
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "compareEle",
          model: _unref(compareObj),
          inline: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "财务费用",
              prop: "financialExpenses"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_el_input, {
                    type: "number",
                    controls: false,
                    modelValue: _unref(compareObj).financialExpenses,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(compareObj).financialExpenses) = $event)),
                    placeholder: "请输入财务费用",
                    clearable: "",
                    onChange: _cache[2] || (_cache[2] = (number) => usdConvert(number, 'financialExpenses'))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("p", _hoisted_3, "USD金额: " + _toDisplayString(_unref(getNumber)(_unref(usdConvertObj).financialExpenses)), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "差异",
              prop: "balance"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_el_input, {
                    type: "number",
                    controls: false,
                    modelValue: _unref(compareObj).balance,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(compareObj).balance) = $event)),
                    placeholder: "请输入差异",
                    clearable: "",
                    onChange: _cache[4] || (_cache[4] = (number) => usdConvert(number, 'balance'))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("p", _hoisted_4, "USD金额: " + _toDisplayString(_unref(getNumber)(_unref(usdConvertObj).balance)), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "坏账",
              prop: "badDebt"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_el_input, {
                    type: "number",
                    controls: false,
                    modelValue: _unref(compareObj).badDebt,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(compareObj).badDebt) = $event)),
                    placeholder: "请输入坏账",
                    clearable: "",
                    onChange: _cache[6] || (_cache[6] = (number) => usdConvert(number, 'badDebt'))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("p", _hoisted_5, "USD金额: " + _toDisplayString(_unref(getNumber)(_unref(usdConvertObj).badDebt)), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "备注",
              prop: "notes"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(compareObj).notes,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(compareObj).notes) = $event)),
                  placeholder: "请输入备注",
                  clearable: "",
                  maxlength: "200",
                  style: {"width":"400px"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createVNode(_component_el_table, {
          border: "",
          data: _unref(compareTable),
          class: "mt-10"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "客户ID",
              prop: "",
              "show-overflow-tooltip": ""
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(props.flowRows.find((_cust) => _cust.customerId !== null)?.customerId ||
            props.invRows.find((_inv) => _inv.clientUsername !== null)?.clientUsername), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "币种",
              prop: "currency"
            }),
            _createVNode(_component_el_table_column, {
              label: "收款金额本位币",
              prop: "flowTotal",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "收款金额",
              prop: "originalFlow",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "手续费",
              prop: "handlingFee",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "订单金额",
              prop: "orderAmount",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "发票金额",
              prop: "originalInvoice",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "发票本位币合计",
              prop: "invoiceTotal",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"])
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(_component_el_divider, null, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(getNumber)(_unref(compareTable)[0].originalInvoice)), 1),
          _hoisted_9,
          _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(getNumber)(_unref(compareTable)[0].orderAmount)), 1),
          _hoisted_11,
          _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(getNumber)(_unref(compareTable)[0].originalFlow)), 1),
          _hoisted_13,
          _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(getNumber)(_unref(compareTable)[0].originalInvoice + _unref(compareTable)[0].orderAmount - _unref(compareTable)[0].originalFlow)), 1),
          _hoisted_15,
          _createVNode(_component_el_button, {
            type: "warning",
            class: "mt-10",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (fillCompareObj('financialExpenses')))
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "warning",
            class: "mt-10",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (fillCompareObj('balance')))
          }, {
            default: _withCtx(() => [
              _hoisted_17
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "warning",
            class: "mt-10",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (fillCompareObj('badDebt')))
          }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          }),
          _hoisted_19,
          _createVNode(_component_el_checkbox, {
            modelValue: _unref(compareObj).bad,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(compareObj).bad) = $event)),
            label: "closedhz",
            size: "large",
            onChange: closedhzChange
          }, null, 8, ["modelValue"])
        ]),
        (__props.flowRows.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createVNode(_component_el_divider, null, {
                default: _withCtx(() => [
                  _hoisted_21
                ]),
                _: 1
              }),
              _createVNode(_component_el_date_picker, {
                clearable: "",
                modelValue: _unref(confirmCloseTime),
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_isRef(confirmCloseTime) ? (confirmCloseTime).value = $event : confirmCloseTime = $event)),
                "value-format": "YYYY-MM-DD",
                type: "date",
                placeholder: "请选择无流水日期"
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_divider, null, {
          default: _withCtx(() => [
            _hoisted_22
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(getNumber)(_unref(compareTable)[0].originalInvoice)), 1),
          _hoisted_25,
          _createElementVNode("span", _hoisted_26, _toDisplayString(_unref(getNumber)(_unref(compareTable)[0].orderAmount)), 1),
          _hoisted_27,
          _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(getNumber)(_unref(compareTable)[0].originalFlow)), 1),
          _hoisted_29,
          _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(getNumber)(_unref(compareObj).financialExpenses)), 1),
          _hoisted_31,
          _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(getNumber)(_unref(compareObj).balance)), 1),
          _hoisted_33,
          _createElementVNode("span", _hoisted_34, _toDisplayString(_unref(getNumber)(_unref(compareObj).badDebt)), 1),
          _hoisted_35,
          _createElementVNode("span", _hoisted_36, _toDisplayString(_unref(getNumber)(
              Math.abs(
                _unref(compareTable)[0].originalInvoice +
                _unref(compareTable)[0].orderAmount -
                _unref(compareTable)[0].originalFlow -
                (_unref(compareObj).financialExpenses || 0) -
                (_unref(compareObj).balance || 0) -
                (_unref(compareObj).badDebt || 0)
              )
            )), 1)
        ]),
        _createVNode(_component_el_collapse, { class: "mt-10" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_collapse_item, {
              title: '(如填写坏账，需勾选相关订单), 勾选订单金额合计：' + _unref(getNumber)(_unref(orderListAmount))
            }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                  ref: "tb",
                  border: "",
                  data: _unref(badOrderList),
                  onSelectionChange: _cache[13] || (_cache[13] = (rows) => _isRef(badDebtOrderRows) //@ts-ignore
 ? badDebtOrderRows.value = rows : badDebtOrderRows = rows ),
                  "max-height": "280px"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      type: "selection",
                      width: "55",
                      fixed: ""
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "坏账金额",
                      fixed: "right",
                      width: "110"
                    }, {
                      default: _withCtx(({ row }) => [
                        _createVNode(_component_el_input, {
                          modelValue: row.badDebt,
                          "onUpdate:modelValue": ($event: any) => ((row.badDebt) = $event),
                          clearable: "",
                          placeholder: "请输入坏账金额"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "订单编号",
                      prop: "no",
                      "show-overflow-tooltip": ""
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "客户名称",
                      prop: "customerUsername",
                      "show-overflow-tooltip": ""
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "发票主体",
                      prop: "invoiceCompany",
                      "show-overflow-tooltip": ""
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "公司名称",
                      prop: "flowCompany",
                      "show-overflow-tooltip": ""
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "订单名称",
                      prop: "name",
                      "show-overflow-tooltip": ""
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "po号",
                      prop: "poNumber",
                      "show-overflow-tooltip": ""
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "币种",
                      prop: "currency",
                      width: "65",
                      "show-overflow-tooltip": ""
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "金额",
                      prop: "amount",
                      align: "right",
                      formatter: _unref(formatNumber),
                      "show-overflow-tooltip": "",
                      width: "125"
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      label: "本位币",
                      prop: "standardMoney",
                      align: "right",
                      formatter: _unref(formatNumber),
                      "show-overflow-tooltip": ""
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      label: "USD金额",
                      prop: "baseCurrencyMoney",
                      align: "right",
                      "show-overflow-tooltip": ""
                    }, {
                      default: _withCtx(({row}) => [
                        _createTextVNode(_toDisplayString(_unref(getNumber)(parseFloat(row.baseCurrencyMoney))), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "状态",
                      prop: "status",
                      "show-overflow-tooltip": ""
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "客户经理",
                      prop: "owner",
                      "show-overflow-tooltip": ""
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "开始时间",
                      prop: "startTime",
                      formatter: _unref(formatTime),
                      "show-overflow-tooltip": ""
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      label: "完工时间",
                      prop: "deliverTime",
                      formatter: _unref(formatTime),
                      "show-overflow-tooltip": ""
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      label: "确认完工时间",
                      prop: "confirmDeliverTime",
                      formatter: _unref(formatTime),
                      width: "120",
                      "show-overflow-tooltip": ""
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      label: "关单时间",
                      prop: "closeTime",
                      formatter: _unref(formatTime),
                      "show-overflow-tooltip": ""
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      label: "确认关单时间",
                      prop: "confirmCloseTime",
                      formatter: _unref(formatTime),
                      width: "120",
                      "show-overflow-tooltip": ""
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      label: "核销时间",
                      prop: "verifyTime",
                      formatter: _unref(formatTime),
                      "show-overflow-tooltip": ""
                    }, null, 8, ["formatter"])
                  ]),
                  _: 1
                }, 8, ["data"])), [
                  [_directive_loading, _unref(orderListFg)]
                ])
              ]),
              _: 1
            }, 8, ["title"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowExchange.value,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((isShowExchange).value = $event)),
      title: "获取汇率",
      width: "400px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          disabled: isSubmitLoading.value,
          onClick: _cache[17] || (_cache[17] = ($event: any) => (isShowExchange.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_39
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          loading: isSubmitLoading.value,
          type: "primary",
          onClick: _cache[18] || (_cache[18] = ($event: any) => (submitExchange()))
        }, {
          default: _withCtx(() => [
            _hoisted_40
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_date_picker, {
          modelValue: exchangeRang.value,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((exchangeRang).value = $event)),
          clearable: false,
          type: "daterange",
          "value-format": "YYYY-MM-DD",
          "range-separator": "至",
          "start-placeholder": "开始日期",
          "end-placeholder": "结束日期"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})